import { Input } from '@/components/ui/input';
import type { MetadataSchemaField } from '@/types/metadata.types';

interface TextInputFieldProps {
  field: MetadataSchemaField;
  value: unknown;
  onChange: (value: unknown) => void;
  error?: string;
  disabled?: boolean;
}

export default function TextInputField({
  field,
  value,
  onChange,
  error,
  disabled,
}: TextInputFieldProps) {
  return (
    <Input
      id={field.fieldKey}
      placeholder={field.placeholder || ''}
      value={(value as string) || ''}
      onChange={(e) => onChange(e.target.value)}
      disabled={disabled}
      maxLength={field.validationRules?.maxLength}
      className={error ? 'border-destructive' : ''}
    />
  );
}
